import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { FrequentlyAskedQuestionsListComponent } from './faq-list/faq-list.component';

const routes: Routes = [
  {
    path: 'faq',
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [{ path: '', component: FrequentlyAskedQuestionsListComponent }],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class FrequentlyAskedQuestionsRoutingModule {}
